/* TIFFO cart box summary V2 — shows the shirts inside each box line in the cart page and drawer. */
(()=>{
  'use strict';
  if(window.__tiffoCartBoxSummaryV2)return;
  window.__tiffoCartBoxSummaryV2=true;

  const EN=(document.documentElement.lang||'').toLowerCase().startsWith('en');
  const TXT=EN?{dir:'ltr',head:'Box contents',count:n=>n+(n===1?' shirt':' shirts')}:{dir:'rtl',head:'محتوى البوكس',count:n=>n+' تيشيرت'};
  const ROOT=()=>window.Shopify?.routes?.root||'/';
  const esc=s=>String(s??'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

  function parseItem(item){
    const p=item?.properties||{};
    if(!p._tiffo_box)return null;
    const rows=[];
    for(let n=1;n<=8;n++){
      const raw=p['تيشيرت '+n]||p['التيشيرت '+n];
      if(raw)rows.push({n,raw:String(raw)});
    }
    if(!rows.length&&p['تفاصيل البوكس']){
      String(p['تفاصيل البوكس']).split('||').forEach((raw,i)=>{if(raw)rows.push({n:i+1,raw})});
    }
    return rows.length?rows:null;
  }

  function split(raw){
    const m=raw.match(/^(.*)\s[-–—]\s([^-–—]+)$/);
    return m?{club:m[1].trim(),size:m[2].trim()}:{club:raw,size:''};
  }

  let busy=false;
  function render(cart){
    const map=new Map((cart?.items||[]).map(i=>[String(i.key),i]));
    document.querySelectorAll('.cart-items__table-row[data-key]').forEach(row=>{
      const item=map.get(String(row.dataset.key));
      const rows=parseItem(item);
      const sig=rows?JSON.stringify(rows):'';
      const old=row.querySelector('.tiffo-cart-box-summary');
      if(old&&old.dataset.sig===sig)return;
      if(old)old.remove();
      if(!rows)return;
      row.classList.add('tiffo-is-box');
      const box=document.createElement('div');
      box.className='tiffo-cart-box-summary';
      box.dir=TXT.dir;
      box.dataset.sig=sig;
      box.innerHTML='<div class="tiffo-cart-box-summary__head"><strong>'+TXT.head+'</strong><span>'+TXT.count(rows.length)+'</span></div><div class="tiffo-cart-box-summary__list">'+rows.map(r=>{
        const s=split(r.raw);
        return '<div class="tiffo-cart-box-summary__row"><b>'+r.n+'</b><span>'+esc(s.club)+'</span><em>'+esc(s.size)+'</em></div>';
      }).join('')+'</div>';
      const anchor=row.querySelector('.cart-items__variants-wrapper')||row.querySelector('.cart-items__product-info')||row.querySelector('.cart-items__details');
      if(anchor)anchor.insertAdjacentElement('afterend',box);
    });
  }

  async function load(){
    if(busy)return;busy=true;
    try{
      const r=await fetch(ROOT()+'cart.js',{cache:'no-store'});
      if(r.ok)render(await r.json());
    }catch(e){}finally{busy=false}
  }

  let t;
  const later=()=>{clearTimeout(t);t=setTimeout(load,150)};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',later,{once:true});else later();
  ['cart:updated','cart:refresh','cart:change','tiffo:cart-changed','shopify:section:load'].forEach(e=>document.addEventListener(e,later));
  new MutationObserver(muts=>{
    for(const m of muts){
      if(m.target.closest&&m.target.closest('.tiffo-cart-box-summary'))continue;
      if([...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('.cart-items__table-row,cart-items-component')||n.querySelector?.('.cart-items__table-row')))){later();break}
    }
  }).observe(document.documentElement,{childList:true,subtree:true});

  const style=document.createElement('style');
  style.textContent=`
    .tiffo-cart-box-summary{margin-top:10px;padding:10px;border:1px solid rgba(201,162,74,.45);border-radius:12px;background:#fffdf7;color:#111;box-sizing:border-box;width:100%}
    .tiffo-cart-box-summary__head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:7px}
    .tiffo-cart-box-summary__head strong{font-size:12px;font-weight:800}
    .tiffo-cart-box-summary__head span{font-size:11px;color:#8A6A1F;font-weight:700}
    .tiffo-cart-box-summary__list{display:grid;gap:5px}
    .tiffo-cart-box-summary__row{display:grid;grid-template-columns:22px minmax(0,1fr) auto;align-items:center;gap:8px;min-height:30px;padding:4px 8px;border-radius:8px;background:#fff;border:1px solid #efe9da}
    .tiffo-cart-box-summary__row>b{width:20px;height:20px;border-radius:50%;background:#C9A24A;color:#111;display:grid;place-items:center;font-size:10px}
    .tiffo-cart-box-summary__row>span{font-size:11.5px;font-weight:700;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
    .tiffo-cart-box-summary__row>em{font-style:normal;font-size:11px;font-weight:800;color:#111;background:#f4f1ea;border-radius:6px;padding:2px 7px}
    .tiffo-is-box .cart-items__properties,.tiffo-is-box .cart-item__properties,.tiffo-is-box dl.product-option,.tiffo-is-box .cart-items__variants-wrapper .product-option{display:none!important}
  `;
  document.head.appendChild(style);
})();
